import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getSsoConfig, redirectToSsoLogin } from 'auth/ssoClient'
import { PageLoader } from 'components/common/Loader'

/**
 * There is no sign-in page of its own. This app is entered from the main Kit19
 * product, which sends the SSO token in the link, so a visit that somehow arrives
 * without a session is forwarded straight to the Kit19 SSO page and comes back
 * through /callback onto the record it wanted. The only thing rendered here is a
 * message when the SSO round trip itself failed (so it cannot loop).
 */
export default function Login() {
  const location = useLocation()
  const sso = getSsoConfig()
  const state = location.state as { from?: string; error?: string } | null
  const target = state?.from
  const ssoError = state?.error

  useEffect(() => {
    if (sso.enabled && !ssoError) redirectToSsoLogin(target)
  }, [sso.enabled, ssoError, target])

  if (sso.enabled && !ssoError) return <PageLoader />

  return (
    <div className="app-shell">
      <div className="auth-error card">
        <h2>{sso.enabled ? 'Sign-in failed' : 'SSO is disabled'}</h2>
        {sso.enabled ? (
          <>
            <p>{ssoError}</p>
            <button type="button" className="btn pri-btn" onClick={() => redirectToSsoLogin(target)}>
              Try again
            </button>
          </>
        ) : (
          <p>
            <code>VITE_SSO_ENABLED=false</code>. Open this app from the main Kit19 product (View / Edit
            entity), which sends the session in the link.
          </p>
        )}
      </div>
    </div>
  )
}
